// extracted by mini-css-extract-plugin
export default {"test_card":"PartWorkReport_test_card__dfjTB","btn_print":"PartWorkReport_btn_print__NssfV","div_print":"PartWorkReport_div_print__mmq93"};